import React, { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import IEvent from '../../interfaces/IEvent';
import {
  EVENT_KIND_COLOR,
  formatEventDate,
  formatEventDescription,
  getEventKind,
  sortEventsDesc,
} from './eventPresentation';

interface IProps {
  events: IEvent[];
  limit?: number;
}

const MARKER_SIZE = 8;

const EventTimeline = ({ events, limit }: IProps) => {
  const visibleEvents = useMemo(() => {
    const sorted = sortEventsDesc(events);
    return limit ? sorted.slice(0, limit) : sorted;
  }, [events, limit]);

  return (
    <Box component="ul" sx={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {visibleEvents.map((event, index) => {
        const isLast = index === visibleEvents.length - 1;
        const dateLabel = formatEventDate(event.createdAt);

        return (
          <Box
            component="li"
            key={event.id ?? `${index}`}
            sx={{ display: 'flex', alignItems: 'stretch', gap: 1.25 }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: MARKER_SIZE }}>
              <Box
                sx={{
                  width: MARKER_SIZE,
                  height: MARKER_SIZE,
                  marginTop: '5px',
                  borderRadius: '50%',
                  flexShrink: 0,
                  backgroundColor: EVENT_KIND_COLOR[getEventKind(event.description)],
                }}
              />
              {!isLast && (
                <Box sx={{ width: '1px', flexGrow: 1, marginTop: '3px', backgroundColor: 'divider' }} />
              )}
            </Box>
            <Box sx={{ minWidth: 0, paddingBottom: isLast ? 0 : 1.5, overflowWrap: 'anywhere' }}>
              <Typography sx={{ fontSize: 12, lineHeight: 1.5, color: 'text.primary' }}>
                {formatEventDescription(event.description)}
              </Typography>
              <Typography sx={{ fontSize: 11, lineHeight: 1.5, color: 'text.secondary' }}>
                {dateLabel}
                {dateLabel && event.username ? ' · ' : ''}
                <Box component="span" sx={{ textTransform: 'capitalize' }}>
                  {event.username}
                </Box>
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default EventTimeline;
